import type { ReactNode } from 'react';

export type ReaderRuntimeSlot = {
  id: string;
  token: symbol;
  ownerId: string;
  epoch: number;
  target: HTMLElement;
  content: ReactNode;
};

let slots: readonly ReaderRuntimeSlot[] = [];
const listeners = new Set<() => void>();
const publish = () => { for (const listener of listeners) listener(); };
export const getReaderRuntimeSlots = () => slots;
export const subscribeReaderRuntimeSlots = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};

export function putReaderRuntimeSlot(slot: ReaderRuntimeSlot): void {
  const index = slots.findIndex((current) => current.id === slot.id);
  slots = index < 0 ? [...slots, slot]
    : slots.map((current, at) => at === index ? slot : current);
  publish();
}

export function removeReaderRuntimeSlot(id: string, token: symbol): void {
  const next = slots.filter((slot) => slot.id !== id || slot.token !== token);
  if (next.length === slots.length) return;
  slots = next;
  publish();
}

export function clearReaderRuntimeSlots(): void {
  if (slots.length === 0) return;
  slots = [];
  publish();
}
